/**
 * Created by jv on 2019-09-10 (12:40).
 */
const log = require("Sources/utils/logger")();

import utils from "Sources/utils/utils";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/session-join.html";
import FormValidator from "Sources/components/form-validator";
import LanguageManager from "Sources/services/language-manager";

require("Styles/components/views/join-session.scss");

class SessionJoinView extends GameView {
  constructor(options) {
    options.html = $(htmlView);
    super(options);

    this.path = "session-join";
    this.sessionId = options.sessionId;
  }

  render() {
    super.render();
    this._setUpEventListeners();

    this.onRender();
  }

  onRender() {
    super.onRender();

    this.formValidator = new FormValidator({
      selector: this.$element.find(".join-session-form"),
      validateOnChange: true,
      rules: {
        "session-id": {
          required: true,
          maxLength: 20,
          validator: (value) => {
            let regex = new RegExp("^[0-9]+$"); // only allow numeric (fontend check only)
            return !utils.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
          }
        },
        "team-name": {
          required: true,
          maxLength: 20,

          validator: (value) => {
            let regex = new RegExp("^[a-zA-Z0-9\-_ ]+$"); // only allow alphanumeric, space, - and _ (keep in sync with GameSessionController.java)
            return !utils.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
          },
          tooltip: LanguageManager.getValueForKey("serious_game.session.form.session_name.tooltip"),
          tooltipPlacement: "right"
        }
      }
    });

    this.formValidator.setValueForKey("session-id", this.sessionId);

    if (__DEVELOPMENT__) {
      $(window).on("keydown", e => {
        if (e.ctrlKey) {
          log.info(e.code);

          if (e.code.startsWith("Digit") || e.code.startsWith("Numpad")) {
            let num = e.code.replace("Digit", "");
            num = num.replace("Numpad", "");
            this.formValidator.setValueForKey("session-id", "123456");
            this.formValidator.setValueForKey("team-name", `Team${num}`);
          }
        }
      })
    }
  }

  getFormSessionId() {
    if (utils.isNotNull(this.formValidator)) {
      let formData = this.formValidator.getFormData();

      return utils.isNotNull(formData) ? formData["session-id"] : null;
    }

    return null;
  }

  getFormTeamName() {
    if (utils.isNotNull(this.formValidator)) {
      let formData = this.formValidator.getFormData();

      return utils.isNotNull(formData) ? formData["team-name"] : null;
    }

    return null;
  }

  showForm() {
    this.$element.find(".join-session-form-wrapper").removeClass("loading");
  }

  showLoadingState() {
    this.$element.find(".join-session-form-wrapper").addClass("loading");
  }

  setJoinButtonLoading(flag) {
    utils.setButtonLoading(this.$element.find(".join-session-btn"), flag);
  }

  setFormError(errorMessage) {
    this.clearFormErrors();
    let $formError = $("<div class='form-error'></div>").text(errorMessage);
    this.$element.find(".form-errors").append($formError);
  }

  clearFormErrors() {
    this.$element.find(".form-errors").empty();
  }

  _setUpEventListeners() {
    this.$element.find(".join-session-btn").off("click").on("click", (e) => {
      let $this = $(e.delegateTarget);

      this.clearFormErrors();
      let isValid = this.formValidator.validate();

      if (isValid) {
        this.setJoinButtonLoading(true);

        if (utils.isFunction(this.onJoinSession)) {
          this.onJoinSession.call(this, $this);
        }
      }
    });
  }
}

module.exports = SessionJoinView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/session-join.js